import { motion } from "framer-motion";
import {
  Mail,
  Users,
  GraduationCap,
  ClipboardCheck,
  ChevronRight,
  ShieldCheck,
} from "lucide-react";

const psacCommittees = [
  {
    code: "DBA",
    name: "Business Administration",
    members: [
      {
        name: "Dr Abu Jahid",
        designation: "Associate Professor",
        position: "Convener",
        email: "abu.jahid@uctc.edu.bd",
      },
      {
        name: "Ms Sakera Begum",
        designation: "Assistant Professor",
        position: "Member",
        email: "sakera@uctc.edu.bd",
      },
      {
        name: "Osman Masud",
        designation: "Lecturer",
        position: "Member",
        email: "masud@uctc.edu.bd",
      },
    ],
  },

  {
    code: "ELL",
    name: "English Language and Literature",
    members: [
      {
        name: "Mohammad Taher Hossain Salim",
        designation: "Associate Professor",
        position: "Convener",
        email: "tahersalim@uctc.edu.bd",
      },
      {
        name: "Mymuna Khatun",
        designation: "Assistant Professor",
        position: "Member",
        email: "mymuna@uctc.edu.bd",
      },
      {
        name: "Bipasha Barua",
        designation: "Lecturer",
        position: "Member",
        email: "bipasha@uctc.edu.bd",
      },
    ],
  },

  {
    code: "IS",
    name: "Islamic Studies",
    members: [
      {
        name: "Md. Obaidullah",
        designation: "Lecturer",
        position: "Convener",
        email: "obaidullah@uctc.edu.bd",
      },
      {
        name: "Md Burhan Uddin Nur",
        designation: "Lecturer",
        position: "Member",
        email: "burhan@uctc.edu.bd",
      },
      {
        name: "Md Kawsar Mahmud",
        designation: "Lecturer",
        position: "Member",
        email: "kawsar@uctc.edu.bd",
      },
    ],
  },

  {
    code: "CE",
    name: "Civil Engineering",
    members: [
      {
        name: "Nure Yeazdani",
        designation: "Lecturer",
        position: "Convener",
        email: "yeazdani@uctc.edu.bd",
      },
      {
        name: "Preetom Chandra Dey",
        designation: "Lecturer",
        position: "Member",
        email: "preetom@uctc.edu.bd",
      },
      {
        name: "Abhi Chowdhury",
        designation: "Lecturer",
        position: "Member",
        email: "abhi@uctc.edu.bd",
      },
    ],
  },

  {
    code: "CSE",
    name: "Computer Science and Engineering",
    members: [
      {
        name: "Md. Abu Jabed",
        designation: "Associate Professor",
        position: "Convener",
        email: "jabed@uctc.edu.bd",
      },
      {
        name: "Sumona Sultana",
        designation: "Lecturer",
        position: "Member",
        email: "sumona@uctc.edu.bd",
      },
      {
        name: "Mohd. Nadib Hasan",
        designation: "Lecturer",
        position: "Member",
        email: "nadib@uctc.edu.bd",
      },
    ],
  },

  {
    code: "EEE",
    name: "Electrical and Electronic Engineering",
    members: [
      {
        name: "Md. Riyad Hossain",
        designation: "Lecturer",
        position: "Convener",
        email: "hriyad8@uctc.edu.bd",
      },
      {
        name: "Nigar Afsana",
        designation: "Lecturer",
        position: "Member",
        email: "nigar@uctc.edu.bd",
      },
      {
        name: "Tajkia Saima Chy",
        designation: "Lecturer",
        position: "Member",
        email: "tajkia@uctc.edu.bd",
      },
    ],
  },

  {
    code: "ME",
    name: "Mechanical Engineering",
    members: [
      {
        name: "Md. Abu Bakkar Sikder",
        designation: "Lecturer",
        position: "Convener",
        email: "abubakkar@uctc.edu.bd",
      },
      {
        name: "Md. Julkar Nayen",
        designation: "Lecturer",
        position: "Member",
        email: "julkar@uctc.edu.bd",
      },
      {
        name: "Daud Hasan",
        designation: "Lecturer",
        position: "Member",
        email: "daud@uctc.edu.bd",
      },
    ],
  },

  {
    code: "MpH",
    name: "Public Health",
    members: [
      {
        name: "Mohammad Injamul Hoq",
        designation: "Assistant Professor",
        position: "Convener",
        email: "injamul@uctc.edu.bd",
      },
      {
        name: "Rifat Nowshin",
        designation: "Lecturer",
        position: "Member",
        email: "nowshin@uctc.edu.bd",
      },
      {
        name: "Mohammed Mohsin",
        designation: "Lecturer",
        position: "Member",
        email: "Dr.mohsin@uctc.edu.bd",
      },
    ],
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: "easeOut",
    },
  },
};

export default function PSACSection() {
  return (
    <section
      id="psac"
      className="relative overflow-hidden bg-[#f6fafc] py-20 sm:py-24"
    >
      {/* Background decoration */}
      <div className="pointer-events-none absolute -left-32 top-20 h-72 w-72 rounded-full bg-[#016c94]/10 blur-3xl" />

      <div className="pointer-events-none absolute -right-32 bottom-10 h-96 w-96 rounded-full bg-[#d4a900]/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">

        {/* =====================================================
            HEADER
        ====================================================== */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="mx-auto mb-14 max-w-3xl text-center"
        >
          {/* Small label */}
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#016c94]/15 bg-[#016c94]/5 px-4 py-2 text-sm font-bold text-[#016c94]">
            <ShieldCheck size={17} />
            Institutional Quality Assurance Cell
          </div>

          {/* Heading */}
          <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Program Self-Assessment
            <span className="block text-[#016c94]">
              Committee (PSAC)
            </span>
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-8 text-slate-600 sm:text-lg">
            Program Self-Assessment Committees of the University of Creative
            Technology Chittagong, organized by academic program.
          </p>

          {/* Stats */}
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Stat
              icon={<ClipboardCheck size={17} />}
              value="08"
              label="Programs"
            />

            <Stat
              icon={<Users size={17} />}
              value="24"
              label="Committee Members"
            />

            <Stat
              icon={<GraduationCap size={17} />}
              value="PSAC"
              label="Quality Assurance"
            />
          </div>
        </motion.div>

        {/* =====================================================
            COMMITTEE GRID
        ====================================================== */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.05 }}
          className="grid gap-7 md:grid-cols-2 xl:grid-cols-3"
        >
          {psacCommittees.map((committee) => (
            <motion.div
              key={committee.code}
              variants={cardVariants}
            >
              <CommitteeCard committee={committee} />
            </motion.div>
          ))}
        </motion.div>

        {/* =====================================================
            BOTTOM INFO
        ====================================================== */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-14 overflow-hidden rounded-3xl bg-gradient-to-r from-[#003f59] via-[#016c94] to-[#007e83] p-8 shadow-xl sm:p-10"
        >
          <div className="flex flex-col items-center justify-between gap-6 text-center md:flex-row md:text-left">

            <div>
              <div className="mb-2 flex items-center justify-center gap-2 text-[#f4d36a] md:justify-start">
                <ShieldCheck size={20} />
                <span className="text-sm font-bold uppercase tracking-widest">
                  Quality Assurance
                </span>
              </div>

              <h3 className="text-2xl font-extrabold text-white sm:text-3xl">
                Program Self-Assessment Committee
              </h3>

              <p className="mt-2 text-sm leading-7 text-white/70">
                Institutional Quality Assurance Cell (IQAC)
                <br />
                University of Creative Technology Chittagong
              </p>
            </div>

            <a
              href="mailto:iqac@uctc.edu.bd"
              className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-white px-5 py-3 font-bold text-[#016c94] shadow-lg transition hover:-translate-y-1 hover:shadow-xl"
            >
              <Mail size={18} />
              Contact IQAC
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}


/* =========================================================
   STAT
========================================================= */

function Stat({ icon, value, label }) {
  return (
    <div className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 shadow-sm">
      <span className="text-[#016c94]">{icon}</span>

      <span className="font-extrabold text-slate-900">
        {value}
      </span>

      <span className="text-sm text-slate-500">
        {label}
      </span>
    </div>
  );
}


/* =========================================================
   COMMITTEE CARD
========================================================= */

function CommitteeCard({ committee }) {
  return (
    <div className="group relative overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all duration-500 hover:-translate-y-2 hover:border-[#016c94]/20 hover:shadow-2xl">

      {/* Top accent */}
      <div className="h-1.5 bg-gradient-to-r from-[#016c94] to-[#00a1a1]" />

      <div className="p-6">

        {/* Program Header */}
        <div className="flex items-start justify-between gap-4">

          <div className="flex items-center gap-4">

            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#016c94]/10 text-lg font-black text-[#016c94] transition-all duration-300 group-hover:bg-[#016c94] group-hover:text-white">
              {committee.code}
            </div>

            <div>
              <h3 className="font-extrabold leading-snug text-slate-900">
                {committee.name}
              </h3>

              <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-slate-400">
                Program Self-Assessment
              </p>
            </div>

          </div>

          <ChevronRight
            size={20}
            className="mt-2 shrink-0 text-slate-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-[#016c94]"
          />
        </div>


        {/* Members */}
        <div className="mt-6 space-y-3">

          {committee.members.map((member, index) => (
            <Member
              key={member.email}
              member={member}
              index={index}
            />
          ))}

        </div>
      </div>

      {/* Bottom glow */}
      <div className="absolute -bottom-20 -right-20 h-40 w-40 rounded-full bg-[#016c94]/5 blur-2xl transition-all duration-500 group-hover:bg-[#016c94]/10" />
    </div>
  );
}


/* =========================================================
   MEMBER
========================================================= */

function Member({ member, index }) {
  const isConvener = member.position === "Convener";

  return (
    <div
      className={`relative rounded-2xl border p-4 transition-all duration-300 ${
        isConvener
          ? "border-[#016c94]/15 bg-[#016c94]/5"
          : "border-slate-100 bg-slate-50/70 hover:border-slate-200 hover:bg-white"
      }`}
    >
      <div className="flex gap-3">

        {/* Number / icon */}
        <div
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-sm font-bold ${
            isConvener
              ? "bg-[#016c94] text-white"
              : "bg-white text-slate-500 shadow-sm"
          }`}
        >
          {String(index + 1).padStart(2, "0")}
        </div>

        <div className="min-w-0 flex-1">

          {/* Name + position */}
          <div className="flex flex-wrap items-start justify-between gap-2">

            <h4 className="font-bold text-slate-900">
              {member.name}
            </h4>

            <span
              className={`shrink-0 rounded-full px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide ${
                isConvener
                  ? "bg-[#016c94] text-white"
                  : "bg-slate-200 text-slate-600"
              }`}
            >
              {member.position}
            </span>

          </div>

          {/* Designation */}
          <p className="mt-1 text-sm font-medium text-[#016c94]">
            {member.designation}
          </p>

          {/* Email */}
          <a
            href={`mailto:${member.email}`}
            className="mt-2 flex min-w-0 items-center gap-1.5 text-xs text-slate-500 transition hover:text-[#016c94]"
            onClick={(e) => e.stopPropagation()}
          >
            <Mail size={13} className="shrink-0" />

            <span className="truncate">
              {member.email}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}